import { NextSeo } from "next-seo";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { HelpPage } from "@nju/feature-portal-help";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function ResetPassword() {
  return (
    <LayoutWrapper>
      <NextSeo
        nofollow={true}
        noindex={true}
        title="nju z aplikacją pomoc techniczna | nju.pl"
      />
      <Header />
      <BlockContent spacing="l">
        <HelpPage />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
